import { render, staticRenderFns } from "./PurposeSwiper.vue?vue&type=template&id=a0a1fb68&scoped=true&"
import script from "./PurposeSwiper.vue?vue&type=script&lang=ts&"
export * from "./PurposeSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./PurposeSwiper.vue?vue&type=style&index=0&id=a0a1fb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a1fb68",
  null
  
)

export default component.exports